import React from "react"

import { Row, Col } from "react-bootstrap"

import WrongRed from "../../images/icons/wdn-wrong-red.svg"
import EditBlue from "../../images/icons/wdn-edit-blue.svg"

import "./timeline.scss"
import { formatDate } from "../../utils/format-date-time"

const TimeLineEducation = props => {
  const { educations, onClick, setDelete } = props

  const handleEditButtonClick = (value, id) => {
    onClick(value, id)
  }
  return (
    <div className="timeline__wrapper ">
      <ul className="experience-timeline">
        {educations &&
          educations.map((education, index) => {
            return (
              <li className="events" key={index}>
                <div className="timeline__border ml-2 mr-2  ">
                  <Row>
                    <Col lg="10" className="" xs="10">
                      <Row>
                        <Col lg="8" xs="12">
                          <h6>
                            {education.degreetype_name}
                            {" - "}
                            {education.degree}
                          </h6>
                          <div className="pb-4">
                            <p>{education.college}</p>
                            <p>{education.description}</p>
                          </div>
                          <div className="pb-4">
                            <p>
                              {formatDate(education.from_year)}
                              {" - "}
                              {!!education.to_year
                                ? formatDate(education.to_year)
                                : "Current"}
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="2" sm="2">
                      <ul className="buttons-edit-delete mb-4 clearfix">
                        <li>
                          <div className="cross">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a
                              aria-hidden="true"
                              onClick={() =>
                                handleEditButtonClick(true, education.id)
                              }
                            >
                              <img src={EditBlue} alt="wdn-wrong-red" />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="cross">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a
                              aria-hidden="true"
                              onClick={() =>
                                setDelete(true, education.id, "EDUCATION")
                              }
                            >
                              <img src={WrongRed} alt="wdn-wrong-red" />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export default TimeLineEducation
